export enum DetailType {
    ExternalColor = 'Culoare Exterioară',
    InternalColor = 'Culoare Interioară',
    ExternalMaterial = 'Material Exterior',
    InternalMaterial = 'Material Interior',
    Includes = 'Vine însoțit',
    HardwareColor = 'Culoare Hardware',
    DesignerId = 'Designer ID',
    EntrupyId = 'Entrupy ID',
    Location = 'Locație',
    Dimension = 'Mărime & Dimensiuni'
}
